import React from 'react'
import { Message, Portal } from 'semantic-ui-react'
import '../App.css';

export default class Toastr extends React.Component{

  dismiss = () => {
    this.props.dismiss();
  }

  render(){
    const { messageHeader, messageBody, messageType, className: customClass } = this.props;
    let className = 'toastr';
    if (messageType) className = `${className} toastr-${messageType}`;
    if (customClass) className = `${className} ${customClass}`;

    return (
      <Portal open>
        <Message floating className={className}>
          {
            !this.props.noDimiss &&
            <i className="close icon" onClick={ this.dismiss.bind(this) }></i>
          }
          {
            messageHeader &&
            <Message.Header>
              {messageHeader}
            </Message.Header>
          }
          <p>
            {messageBody}
          </p>
        </Message>
      </Portal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/toastr.js